module.exports = __webpack_public_path__ + "static/img/plan1.7fb9230.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/benjyfishy/training-plan/plan1.png
// module id = VylH
// module chunks = 35